import { Group, Vector3, Geometry, Line, WireframeGeometry, LineBasicMaterial, Color, BufferGeometry, SphereGeometry, BufferAttribute, MathUtils, LineSegments } from 'three';
import { TWEEN } from 'three/examples/jsm/libs/tween.module.min.js';

class Ems4 extends Group {
    constructor(parent) {
        // Call parent Group() constructor
        super();

        const material = new LineBasicMaterial( {
	          color: new Color("rgb(0, 0, 0)"),
	          linewidth: 4,
	          linecap: 'round', //ignored by WebGLRenderer
	          linejoin:  'round' //ignored by WebGLRenderer
        } );
        const material2 = new LineBasicMaterial( {
	          color: new Color("rgb(255, 0, 0)"),
	          linewidth: 4,
	          linecap: 'round', //ignored by WebGLRenderer
	          linejoin:  'round' //ignored by WebGLRenderer
        } );
        material.color.r = .1;
        material.color.g = .4;
        material.color.b = .7;

        // Init state
        this.state = {
            pstate: parent.state,
            velocity: new Vector3(0,0,0),
            hp : 12.0,
            collide: this.collide.bind(this),
            takeDam: this.takeDam.bind(this),
            mat: material,
            ready: false,
            stage: 0,
            target: new Vector3(0,0,0),
            starget: new Vector3(0,0,0),
            spike1: undefined,
            spike2: undefined,
            spike3: undefined,
            spike4: undefined,
            circ: undefined,
            sphere: undefined,
        };

        var geometry = new Geometry();

	      geometry.vertices.push(new Vector3(0, 0, -2));
        geometry.vertices.push(new Vector3(0, 0, 2.5));
        geometry.vertices.push(new Vector3(0, 6, 1));
        geometry.vertices.push(new Vector3(0, 6, -2));
        geometry.vertices.push(new Vector3(0, 0, -2));

        var geometry2 = new Geometry();
        geometry2.vertices.push(new Vector3(2, 0, 0));
        geometry2.vertices.push(new Vector3(-2, 0, 0));

        var geometry3 = new Geometry();
        geometry3.vertices.push(new Vector3(1, 0, 0));
        geometry3.vertices.push(new Vector3(0, 1, 0));
        geometry3.vertices.push(new Vector3(-1, 0, 0));
        geometry3.vertices.push(new Vector3(0, -1, 0));
        geometry3.vertices.push(new Vector3(1, 0, 0));

        var geometry4 = new Geometry();
        geometry4.vertices.push(new Vector3(-.25, 0, 0.2));
        geometry4.vertices.push(new Vector3(.25, 0, 0));
        geometry4.vertices.push(new Vector3(0, 3, 0));
        geometry4.vertices.push(new Vector3(-.25, 0, 0.2));
        geometry4.vertices.push(new Vector3(-.25, 0, -0.2));
        geometry4.vertices.push(new Vector3(0, 3, 0));

        var geometry5 = new Geometry();
        for(var i = 0; i<=10; i++){
            geometry5.vertices.push(new Vector3(Math.sin(.628*i)*15, Math.cos(.628*i)*15, 0));
        }

        const geometry6 = new SphereGeometry( 15, 10, 8);

        const line = new Line(geometry, material);
        const line2 = new Line(geometry, material);
        line.position.x += 2;
        line2.position.x -= 2;

        const line3 = new Line(geometry2, material);
        const line4 = new Line(geometry2, material);
        const line5 = new Line(geometry2, material);
        const line6 = new Line(geometry2, material);

        const line7 = new Line(geometry3, material2);

        const spike1 = new Line(geometry4, material2);
        const spike2 = new Line(geometry4, material2);
        const spike3 = new Line(geometry4, material2);

        const circ = new Line(geometry5, material2.clone());


        const wireframe2 = new WireframeGeometry( geometry6 );

        const sphere = new LineSegments( wireframe2 , material2.clone());

        spike1.position.y = 5;
        spike1.position.z = -3;
        spike2.position.y = 4;
        spike2.position.z = -3;
        spike2.position.x = 2;
        spike3.position.y = 4;
        spike3.position.z = -3;
        spike3.position.x = -2;

        line3.position.z = -2;
        line4.position.z = 2.5;
        line5.position.z = 1;
        line6.position.z = -2;
        line5.position.y = 6;
        line6.position.y = 6;
        line7.position.y = 3;


        this.add(line);
        this.add(line2);
        this.add(line3);
        this.add(line4);
        this.add(line5);
        this.add(line6);
        this.add(line7);

        this.add(spike1);
        this.add(spike2);
        this.add(spike3);

        this.add(circ);
        this.add(sphere);

        var rad = MathUtils.randFloat(0, 6.28);
        var dist = MathUtils.randFloat(35, 50);
        this.state.target.y = 0;
        this.state.target.x = Math.sin(rad)*dist;
        this.state.target.z = Math.cos(rad)*dist;

        circ.visible = false;
        circ.material.transparent = true;
        circ.material.opacity = 0.5;
        sphere.visible = false;

        this.state.spike1 = spike1;
        this.state.spike2 = spike2;
        this.state.spike3 = spike3;
        this.state.spike4 = spike1;
        this.state.circ = circ;
        this.state.sphere = sphere;

        this.name = "ems4";

        // Add self to parent's update list
        parent.addToUpdateList(this);
        parent.addToColliderList(this);
    }

    takeDam(){
        this.state.hp -= this.state.pstate.damage;
        this.state.mat.color.r = 1;
        this.state.mat.color.g = 1;
        this.state.mat.color.b = 1;
    }

    collide(){
        const rayO = this.state.pstate.cameraP.clone();
        const rayD = this.state.pstate.playerPos.clone();
        rayD.y += 10;
        rayD.sub(rayO);
        rayD.normalize();
        const norm = this.state.pstate.playerPos.clone().sub(this.position).normalize();
        const dist = norm.dot(this.position);

        const a = rayD.dot(norm);
        const b = rayO.dot(norm) - dist;

        if (a > 0.01 || a < -0.01){
            const len = -b / a;
            if (len > 0.01 && len < this.state.pstate.dist){
                const intersect = rayO.clone().add(rayD.multiplyScalar(len));
                 intersect.sub(this.position);

                 if (intersect.y > -0.9 && intersect.y < 7.0){
                    intersect.y = 0;
                    if (intersect.length() < 2.8){
                        this.state.pstate.dist = len;
                        this.state.pstate.target = this;
                        this.state.pstate.impact.copy(rayO.add(rayD));
                    }
                }
            }
        }
    }

    update(timeStamp) {
        // Advance tween animations, if any exist
        this.state.pstate.next = false;
        if (this.state.stage == 0){
            this.lookAt(this.state.pstate.playerPos);
            var v = this.state.target.clone().add(this.state.pstate.playerPos);
            v.add(this.state.pstate.playerV.clone().multiplyScalar(300));
            v.sub(this.position);
            v.y = 0;
            v.normalize();
            v.multiplyScalar(0.1);
            this.position.add(v);

            if (this.position.distanceTo(this.state.pstate.playerPos) < 85){
                this.state.stage = 1;
                this.state.starget.copy(this.state.spike1.position);
                const worldP = this.state.pstate.playerPos.clone().add(this.state.pstate.playerV.clone().multiplyScalar(80));
                worldP.x+= MathUtils.randFloat(-20, 20);
                worldP.z += MathUtils.randFloat(-20, 20);
                worldP.y = 1;
                this.state.circ.lookAt(this.position.x, this.position.y+5000, this.position.z);
                this.state.circ.position.copy(this.worldToLocal(worldP));
                this.state.circ.visible = true;
            }
        }
        if (this.state.stage == 1){
            this.state.spike1.position.y += 4;
            if (this.state.spike1.position.y > 210){
                this.state.stage = 2;
                this.state.spike1.rotation.x = 3.14;
                this.state.spike1.position.x = this.state.circ.position.x;
                this.state.spike1.position.z = this.state.circ.position.z;
            }
        }
        if (this.state.stage == 2){
            this.state.spike1.position.y -= 4;
            if (this.state.spike1.position.y <= this.state.circ.position.y){
                this.state.stage = 3;
                this.state.sphere.visible = true;
                this.state.sphere.material.color.r = 1;
                this.state.sphere.material.color.g = 1;
                this.state.sphere.material.color.b = 1;
                this.state.sphere.position.copy(this.state.circ.position);
                this.state.circ.visible = false;
            }
        }
        if (this.state.stage == 3){
            this.state.sphere.material.color.r -= 0.025;
            this.state.sphere.material.color.g -= 0.05;
            this.state.sphere.material.color.b -= 0.05;
            if (this.state.pstate.playerPos.distanceTo(this.state.sphere.getWorldPosition()) < 15.5){
                this.state.pstate.hurt = true;
                this.state.sphere.material.opacity = 0.2;
                this.state.sphere.material.color.g = 0.7;
                this.state.sphere.material.color.b = 0.7;
                this.state.sphere.material.transparent = true;
            }
            if(this.state.sphere.material.color.r < 0.5){
                this.state.sphere.material.color.r = 1;
                this.state.sphere.visible = false;
                this.state.stage = 0;
                this.state.spike1.position.copy(this.state.starget);
                this.state.spike1.rotation.x = 0;
                this.state.spike1 = this.state.spike2;
                this.state.spike2 = this.state.spike3;
                this.state.spike3 = this.state.spike4;
                this.state.spike4 = this.state.spike1;
            }
        }





        if (this.state.mat.color.b > .7){
            this.state.mat.color.r -= .15;
            this.state.mat.color.g -= .1;
            this.state.mat.color.b -= .05;
        }

    }
}


export default Ems4;
